<template>
  <van-switch v-model="value" />
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "Setting",
  props: {
    configuration: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState("setting", ["configurations"]),
    value: {
      set() {
        this.TOGGLE_CONFIGURATION(this.configuration.model);
      },
      get() {
        const { configurations, configuration } = this;
        return configurations[configuration.model];
      }
    }
  },
  methods: {
    ...mapMutations("setting", ["TOGGLE_CONFIGURATION"])
  }
};
</script>
